import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	text-align: center;
	margin: 0 auto;
	color: ${CSSVars.black};

	.hero-wrapper {
		background: url(/assets/hero-bg.webp);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center 0%;
		color: ${CSSVars.white};

		.inner-wrapper {
			padding: 80px 20px 50px;

			@media screen and (min-width: ${CSSVars.breakpointLG}) {
				padding: 120px 40px 50px;
			}
		}
	}

	h1 {
		margin: 0 auto;
		font-size: ${CSSVars.fontSizeXL};
		max-width: 930px;
		margin-bottom: 20px;
		font-weight: 300;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize2XL};
		}
	}

	h5 {
		margin: 0 auto;
		font-size: ${CSSVars.fontSizeLG};
		font-weight: 300;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	.published-date {
		margin: 8px auto 0;
		font-size: ${CSSVars.fontSizeSM};
		font-weight: 300;
		opacity: 0.7;
	}

	.tags {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 10px;

		.tag {
			padding: 5px 15px 3px 15px;
			border-radius: 20px;
			border: 1px solid ${CSSVars.blue300};
			background-color: ${CSSVars.white};
			color: ${CSSVars.blue};
			font-size: ${CSSVars.fontSizeXS};
			transition: 0.2s;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeSM};
			}

			&:hover {
				opacity: 0.8;
			}
		}
	}

	#tableWrapper {
		overflow: auto !important;
		max-width: 640px;
	}

	deckgo-highlight-code {
		width: 100%;
		max-width: 640px;
	}

	span.code {
		background: rgba(0, 0, 0, 0.05);
		padding: 2px 5px;
		border: 1px solid rgba(0, 0, 0, 0.1);
		margin: 0 2px;
		border-radius: 2px;
	}

	img {
		text-align: center;
		max-height: 100%;
		max-width: 100%;
		object-fit: cover;
		border-radius: 3px;
		aspect-ratio: 16/9;

		@media screen and (max-width: 450px) {
		}

		&:first-of-type {
			> * {
				width: 100% !important;
			}
		}
	}

	.blog-post-content {
		padding: 0 20px;
		margin: 0 auto;
		font-family: ${CSSVars.secondaryFont};
		line-height: 1.7;
		text-align: left;
		max-width: 970px;

		iframe.ql-video {
			// for vimeo videos
			width: 100%;
			aspect-ratio: 16/9;
			border-radius: 10px;
		}

		p {
			margin: 20px 0;
			font-size: ${CSSVars.fontSizeMD};

			br {
				display: none;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}

		h2 {
			font-size: ${CSSVars.fontSizeXL};
			line-height: 1.7em;
			margin-top: 40px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		h3,
		h4,
		h5,
		h6 {
			font-size: ${CSSVars.fontSizeLG};
			line-height: 1.7em;
			margin-top: 40px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}
		}

		.content-layout {
			display: flex;
			gap: 30px;
			flex-direction: column;

			img {
				/* max-height: 450px; */
				max-width: 100%;
				object-fit: contain;
				border: 1px solid ${CSSVars.gray100};
				border-radius: 10px;
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				gap: 50px;
				flex-direction: row;
			}

			.side-banner {
				height: fit-content;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					max-width: 240px;
					position: sticky;
					top: 10px;
				}

				.banner {
					@media screen and (max-width: ${CSSVars.breakpointMD}) {
						display: none;
					}

					margin-top: 20px;
					padding: 20px;
					border-radius: 10px;

					img {
						object-fit: cover;
						border-radius: 5px;
						height: 100px;
						max-width: 100%;
						width: 100%;
						margin: 0;
					}

					.title {
						margin: 0;
						font-size: 16px;
					}

					.text {
						font-weight: 300;
						font-size: 14px;
						margin: 5px 0 0;
					}

					a {
						margin-top: 20px;
						padding: 5px 15px;
						width: 100%;
					}
				}

				.table-of-contents {
					max-width: 100%;
					width: 100%;
					background-color: ${CSSVars.white};
					border: 2px solid ${CSSVars.gray50};
					border-radius: 10px;
					padding: 20px 10px;
					display: flex;
					flex-direction: column;
					font-family: ${CSSVars.primaryFont};

					.title {
						font-size: 14px;
						margin: 0 0 10px;
						padding: 0 10px;
						color: ${CSSVars.black};
						font-weight: 600;
					}

					a {
						font-weight: 400;
						font-size: 14px;
						padding: 5px 10px 5px 25px;
						border-radius: 5px;
						margin-bottom: 2px;
						text-decoration: none;
						color: ${CSSVars.black};
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1; /* number of lines to show */
						line-clamp: 1;
						-webkit-box-orient: vertical;
						transition: 0.2s;
						position: relative;
						gap: 5px;

						div {
							position: absolute;
							min-width: 5px;
							min-height: 5px;
							border-radius: 50em;
							background-color: ${CSSVars.blue};
							left: 10px;
							top: 50%;
							transform: translateY(-50%);
						}

						&:hover {
							color: ${CSSVars.blue500};
						}

						&.active {
							background: ${CSSVars.gray50};
							color: ${CSSVars.blue500};
						}
					}
				}
			}

			main.content {
				flex: 1;

				.author-section {
					display: flex;
					gap: 20px;
					margin-top: 60px;
					padding: 30px;
					background-color: ${CSSVars.gray50};
					border-radius: 12px;
					align-items: flex-start;

					@media screen and (max-width: ${CSSVars.breakpointSM}) {
						flex-direction: column;
						align-items: center;
						text-align: center;
					}

					.author-image {
						flex-shrink: 0;

						img {
							width: 90px;
							height: 90px;
							border-radius: 50%;
							object-fit: cover;
							border: none;
							margin: 0;
							aspect-ratio: 1/1;
						}
					}

					.author-info {
						flex: 1;

						.author-name {
							margin: 0 0 8px;
							font-size: ${CSSVars.fontSizeLG};
							font-weight: 600;
							color: ${CSSVars.blue500};
							font-family: ${CSSVars.primaryFont};

							@media screen and (min-width: ${CSSVars.breakpointMD}) {
								font-size: ${CSSVars.fontSizeXL};
							}
						}

						.author-description {
							margin: 0 0 16px;
							font-size: ${CSSVars.fontSizeSM};
							color: ${CSSVars.gray600};
							line-height: 1.6;

							@media screen and (min-width: ${CSSVars.breakpointMD}) {
								font-size: ${CSSVars.fontSizeMD};
							}
						}

						.author-socials {
							display: flex;
							gap: 12px;

							@media screen and (max-width: ${CSSVars.breakpointSM}) {
								justify-content: center;
							}

							a {
								display: flex;
								align-items: center;
								justify-content: center;
								width: 28px;
								height: 28px;
								padding: 0;
								transition: opacity 0.2s ease;

								&:hover {
									opacity: 0.7;
									text-decoration: none;
								}

								img {
									width: 24px;
									height: 24px;
									border-radius: 0;
									margin: 0;
									border: none;
									object-fit: contain;
									aspect-ratio: 1/1;
								}
							}
						}
					}
				}
			}
		}

		.cta {
			padding: 12px 24px;
			margin: 30px auto;
			display: block;
			width: fit-content;
			border-radius: 8px;
			font-weight: 600;
			transition: background 0.3s;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 40px auto;
			}

			&.button,
			&.download {
				text-decoration: none !important;
				color: white;
				background-color: ${CSSVars.blue500};

				&:hover {
					background: linear-gradient(270deg, ${CSSVars.pink300} 0%, ${CSSVars.blue500} 100%);
				}
			}

			&.link {
				font-size: 18px;
				color: ${CSSVars.blue500};
				background: none;
			}
		}

		.html {
			width: 100%;
			border-radius: 5px;
			min-height: unset;
			max-width: 990px;
			height: fit-content;
		}

		.quotes-container {
			display: flex;
			gap: 40px;
			margin: 20px 0;

			img {
				width: 40px;
				height: 40px;
				border-radius: 10px;
				object-fit: cover;
				margin: 0;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					width: 65px;
					height: 65px;
				}
			}

			.title {
				color: #141414;
				position: relative;
				margin: 0;

				span {
					margin-bottom: 5px;
					display: block;
				}

				.quotes-text {
					p {
						margin: 0;
					}
				}

				&::before {
					content: '';
					position: absolute;
					left: -20px;
					border: 1px solid ${CSSVars.blue500};
					top: 0;
					bottom: 0;
				}
			}
		}

		.banner-container {
			margin: 30px 0;
			border-radius: 12px;
			border: none;
			text-align: center;
			padding: 24px 28px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 40px 0;
				padding: 28px 32px;
			}

			h3 {
				margin: 0 0 8px 0;
				font-size: ${CSSVars.fontSizeMD};
				text-align: center;
				font-weight: 700;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
				}
			}

			p {
				margin: 0;
				font-size: ${CSSVars.fontSizeSM};
				line-height: 1.65;
				font-weight: 400;

				&.small {
					margin: 0;
				}

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeMD};

					&.small {
						margin: 0;
					}
				}
			}

			a {
				color: white;
				padding: 10px 20px;
				text-decoration: none !important;
				margin: 15px auto 0;

				&.small {
					margin: 10px auto 0;
				}
			}
		}
		.tldr {
			margin-top: 30px;
			border-radius: 10px;
			background-color: ${CSSVars.gray50};
			font-size: ${CSSVars.fontSizeMD};
			font-weight: 300;
			padding: 20px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				padding: 30px 50px;
				font-size: ${CSSVars.fontSizeLG};
			}

			span {
			}
		}

		img {
			&.main-img {
				width: 930px;
				border-radius: 10px;
				margin: 30px 0;
				max-width: 100%;
				height: auto;
				aspect-ratio: 930 / 580;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					margin: 50px 0;
				}
			}
		}

		figure {
			margin: 30px auto;
			max-width: 930px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				margin: 50px auto;
			}

			img {
				aspect-ratio: auto;
				object-fit: contain;
				height: auto;
				width: 100%;
				max-width: 100%;
				display: block;
				border-radius: 10px;
			}
		}

		table {
			border-collapse: collapse;
			width: 100%;
			& td,
			& th {
				border: 1px solid #ddd;
				padding: 8px;
			}

			& tr:nth-child(odd) {
				background-color: #f2f2f2;
			}

			& tr:nth-child(1) {
				background-color: #454545;
				color: rgb(240, 240, 240);
			}

			& th {
				padding-top: 12px;
				padding-bottom: 12px;
				text-align: left;
				background-color: #04aa6d;
				color: white;
			}
		}

		blockquote {
			position: relative;
			&::before {
				content: '';
				position: absolute;
				left: -10px;
				border: 1px solid ${CSSVars.blue500};
				top: 0;
				bottom: 0;
			}
		}

		.wp-block-buttons {
			&.aligncenter {
				margin: 40px auto;
			}
			.wp-block-button__link {
				color: white;
				padding: 1rem 2rem;
				background: ${CSSVars.blue500};
				font-size: ${CSSVars.fontSizeSM};
				border-radius: 9px !important;
				text-decoration: none;
				transition: 0.2s;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeMD};
				}

				&:hover {
					transform: translateY(4px);
				}
			}
		}

		img {
			margin: 20px 0;

			&.infographic {
				span {
					width: 450px !important;
					@media screen and (max-width: 550px) {
						width: 100%;
					}
				}
			}
			img {
				max-width: 100%;
				height: auto;
			}
		}

		.wp-block-embed {
			margin: 0 0 20px;
			text-align: center;
		}

		figcaption {
			color: ${CSSVars.gray400};
			font-style: italic;
			font-size: 16px;
			text-align: center;
		}

		img {
			max-width: 100%;
		}

		a {
			color: ${CSSVars.blue500};
			padding: 11px 0;

			&:hover {
				text-decoration: underline;
			}
		}

		ul,
		ol {
			margin: 20px 0;
			padding: 0 30px;
		}

		ul {
			list-style: disc;
		}

		ol {
			list-style: decimal;
		}

		li {
			margin-bottom: 10px;
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	.might-like {
		margin-top: 10rem !important;
		margin: auto;
		text-align: center;
		padding: 0 20px;

		h3 {
			font-size: ${CSSVars.fontSize2XL};
		}

		.post-cards-wrapper {
			max-width: 930px;
			display: flex;
			flex-wrap: wrap;
			gap: 50px;
			margin: 50px auto 100px;

			justify-content: center;

			a {
				background-color: ${CSSVars.white};
				position: relative;
				border: 1px solid ${CSSVars.gray50};
				border-radius: 10px;
				width: 100%;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					max-width: 275px;
				}
			}

			.post {
				border-radius: 10px;
				overflow: hidden;

				&:hover {
					.details {
						.read-more {
							color: ${CSSVars.blue300};
						}
					}
				}

				img {
					object-fit: cover;
					height: 200px;
					width: 100%;
					border-radius: 10px 10px 0 0;
				}

				.details {
					padding: 20px 20px 40px;
					color: ${CSSVars.gray900};

					h3 {
						align-self: flex-start;
						text-align: left;
						line-height: normal;
						max-width: 100%;
						font-size: ${CSSVars.fontSizeSM};

						@media screen and (min-width: ${CSSVars.breakpointMD}) {
							font-size: ${CSSVars.fontSizeMD};
							max-width: 240px;
						}
					}

					.author {
						text-align: left;
						font-size: ${CSSVars.fontSizeXS};
						color: ${CSSVars.gray400};
						font-weight: 300;
						margin: 5px 0 10px;
					}

					.read-more {
						color: ${CSSVars.blue500};
						font-size: ${CSSVars.fontSizeSM};
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 10px;
						margin-left: auto;
						transition: 0.2s;
						width: fit-content;
						border: none;
						background-color: transparent;
						cursor: pointer;

						position: absolute;
						bottom: 20px;
						right: 20px;
						font-family: ${CSSVars.primaryFont};

						&:hover {
							color: ${CSSVars.blue300};
						}
					}
				}
			}
		}
	}
`;
